import React, { useState, useEffect, useRef, useCallback } from "react";
import OtpInput from "react-otp-input";
import OtpPageWrapper from "./OtpPageStyle";
import { withTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { config } from "../../../../config";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../../../redux/actions/travel";
import CountdownTimer from "./CountdownTimer";
import * as commonServices from "../../../../services/common";
import * as globalUtils from "../../../../helpers/utils";

const OtpPage = (props) => {
  const { forGoogleTagging = "" } = props;
  const [otp, setOtp] = useState("");
  const dipatch = useDispatch();
  const toast = useRef(null);
  // const [display, setDisplay] = useState(show);
  const [resetCounter, updateResetCounter] = useState(false);
  const [canResend, setCanResend] = useState(false);
  const [loader, setLoader] = useState(false);
  const { businessLine } = useSelector((state) => state.travel);

  // useEffect(() => {
  //   if (props.show) {
  //     sendOTP();
  //   }
  // }, [props.show]);

  //  for Google tagging (when user shows the otp popup)
  // useEffect(() => {
  //   if (props.show) {
  //     window.dataLayer = window.dataLayer || [];
  //     window.dataLayer.push({
  //       event: "travel_new_addOtpBegin_v2",
  //       item_name: "Travel Insurance New",
  //       item_category: "Travel Insurance",
  //       item_class: "Individual",
  //       funnel_step: "step_3",
  //       travelling_to: forGoogleTagging,
  //     });
  //   }
  // }, [props.show]);

  const sendOTP = useCallback(() => {
    dipatch(setLoading(true));
    const request = {
      idNumber: props.nationalId,
      mobile: globalUtils.prepareMobileNumber(props.mobileNumber),
      channel: "Portal",
      businessService: "StorePortal",
      language: globalUtils.getNumberRepresentedLanguageCode(
        props.i18n.language
      ),
      customText: "",
      module: props.module,
    };
    commonServices
      .sendOTPwithFlag(request)
      .then((response) => {
        dipatch(setLoading(false));
        if (response.data.status == "1") {
          props.setIsInternal(response?.data?.isInternal);
          toast.current.show({
            severity: "success",
            detail: props.t("otp-send-successfully"),
            life: 10000,
          });
        } else {
          toast.current.show({
            severity: "error",
            detail: response.data.resultMessage,
            life: 10000,
          });
        }
      })
      .catch((err) => {
        dipatch(setLoading(false));
      });
  }, [props.mobileNumber, props.i18n.language, toast, dipatch]);

  const verifyOTP = () => {
    const request = {
      isInternal: props.isInternal,
      idNumber: props.nationalId,
      mobile: globalUtils.prepareMobileNumber(props.mobileNumber),
      channel: "Portal",
      otpCode: otp,
      language: globalUtils.getNumberRepresentedLanguageCode(
        props.i18n.language
      ),
    };
    setLoader(true);
    dipatch(setLoading(true));
    commonServices
      .validateOTPWithFlag(request)
      .then((response) => {
        console.log("bbb");

        dipatch(setLoading(false));
        setLoader(false);
        if (
          response.data.status == "1" ||
          response.data.status == "S" ||
          response.status == "1" ||
          response.status == "S"
        ) {
          window.lmSMTObj.track("OTPVerify", {
            status: "Success",
            productName: "Property & Casualty Insurance",
            subProductName: "Travel Insurance",
          });
          props.onSuccessVerify(true);
        } else {
          window.lmSMTObj.track("OTPVerify", {
            status: "Fail",
            productName: "Property & Casualty Insurance",
            subProductName: "Travel Insurance",
          });
          // props.onSuccessVerify(true); // needs to comment before commit.....
          // for Google tagging (invalid otp)
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "error_displayed",
            error_location: "Travel Insurance New",
            funnel_step: "step_5",
            error_messages: response.data.statusDescritpion,
          });
          toast.current.show({
            severity: "error",
            detail: response.data.statusDescritpion,
            life: 10000,
          });
        }
      })
      .catch((error) => {
        window.lmSMTObj.track("OTPVerify", {
          status: "Fail",
          productName: "Property & Casualty Insurance",
          subProductName: "Travel Insurance",
        });
        // for Google tagging (invalid otp)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "error_displayed",
          error_location: "Travel Insurance New",
          funnel_step: "step_5",
          error_messages: "Server error",
        });
        dipatch(setLoading(false));
        setLoader(false);
      });
  };

  const resendOTP = () => {
    updateResetCounter(true);
    setCanResend(false);
    sendOTP();
    setTimeout(() => {
      updateResetCounter(false);
    }, 1000);
  };

  // REBRANDING COLORS
  let businessColor = globalUtils.BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === globalUtils.BUSINESS_LINE_PATHS.STC)
    businessColor = globalUtils.BUSINESS_LINE_COLORS.STC;

  return (
    <Dialog
      visible={props.show}
      showHeader={false}
      closable={true}
      modal={true}
      onHide={props.cancelOTP}
      contentStyle={{ padding: "20px", borderRadius: "10px" }}
    >
      <Toast ref={toast} />
      <OtpPageWrapper>
        <div className="container-fluid">
          <div className="d-flex justify-content-center">
            <div className="col-12 col-sm-12">
              <div className="d-flex justify-content-center">
                <h2
                  className={
                    businessLine
                      ? `otpVerificationTitle-${businessLine} otpVerificationTitle`
                      : "otpVerificationTitle"
                  }
                >
                  {props.t("otp-verification-title")}
                </h2>
              </div>
              <div className="d-flex justify-content-center">
                <p className="otpSentMessageStyle">
                  {props.isInternal
                    ? props.t("otp-sent-mobile") + " " + props.t("ending-with")
                    : props.t("otp-sent-mobile-absher")}
                  <br />
                  {props.isInternal && props.mobileNumber && (
                    <span className="lato">
                      *{props.mobileNumber.substring(6, 10)}
                    </span>
                  )}
                </p>
              </div>
              <h4 className="countdownTextStyle">
                {props.t("remaining-time")}:
                <span className="countdownStyle">
                  <CountdownTimer
                    onFinish={() => setCanResend(true)}
                    resetCounter={resetCounter}
                    count={config.otpPeriod}
                  />
                </span>
              </h4>
              <div dir="ltr" className="d-flex justify-content-center">
                <OtpInput
                  isInputNum={true}
                  value={otp}
                  onChange={(e) => setOtp(e)}
                  placeholder="0000"
                  focusStyle={{
                    border: "1px solid #EAEAEA",
                    outline: "none",
                    width: "60px",
                    height: "60px",
                  }}
                  separator={<span>&nbsp;&nbsp;&nbsp;</span>}
                  numInputs={4}
                  inputStyle="containerStyle lato"
                />
              </div>
              <h3 className="resendOtp text-center">
                {props.t("didnt-receive-otp")}
                <br />
                {props.t("to-resend-the-pin")}.
              </h3>
              <h3 className="text-center">
                <Button
                  className="d-block p-button-text mx-auto my-2"
                  disabled={!canResend}
                  style={{ color: businessColor }}
                  label={props.t("click-here")}
                  onClick={resendOTP}
                />
              </h3>
              <div className="d-flex justify-content-center verifyButtonDiv">
                <Button
                  className="otpVerifybutton"
                  loading={loader}
                  type="button"
                  iconPos="right"
                  onClick={verifyOTP}
                  label={props.t("verify")}
                  style={{ background: businessColor, border: businessColor }}
                />
              </div>
            </div>
          </div>
        </div>
      </OtpPageWrapper>
    </Dialog>
  );
};

export default withTranslation()(OtpPage);
